import React, { useRef, useState } from "react";
import {
  intl,
  HTTP_STATUS,
  DmsTable,
  DmsTableDeleteButton,
  DmsButtonGroup,
  DmsFlexContainer,
  fetchData,
  DmsButton,
  DmsTableEditButton,
  DmsModal,
  DmsTextField
} from "dmsbasereact";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";

export const TrainingsTab = () => {
  const table = useRef(null);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);

  const [newTrainingName, setNewTrainingName] = useState("");
  const [newTrainingDescription, setNewTrainingDescription] = useState("");
  const [newTrainingExpiration, setNewTrainingExpiration] = useState("");

  const handleOpenCreateModal = () => setCreateModalOpen(true);
  const handleCloseCreateModal = () => {
      setCreateModalOpen(false);
      setNewTrainingName("");
      setNewTrainingDescription("");
      setNewTrainingExpiration("");
  };

  const handleCreateSave = async () => {
    if (!newTrainingName) {
      Swal.fire({ icon: "warning", title: intl.get("MissingInformation").d("Missing Information"), text: intl.get("PleaseEnterName").d("Please enter a name.") });
      return;
    }

    try {
      const payload = {
          name: newTrainingName,
          description: newTrainingDescription,
          expiration: newTrainingExpiration,
      }
      const response = await fetchData('/training', 'POST', true, payload);
      if (response.status !== HTTP_STATUS.CREATED_201) {
        throw new Error(response?.data?.detail || "Failed to save training.");
      }

      Swal.fire({ icon: "success", title: intl.get("Success").d("Success"), text: intl.get("TrainingCreated").d("Training created successfully.") });
      table.current.updateTable();
      handleCloseCreateModal();
    } catch (error) {
      Swal.fire({ icon: "error", title: intl.get("Error").d("Error"), text: error.message });
    }
  };

  const header = [
    { label: intl.get("Name").d("Name"), column_name: "name", filter: true },
    { label: intl.get("Description").d("Description"), column_name: "description", filter: true, control: 'textarea' },
    { label: intl.get("ValidityMonths").d("Validity (Months)"), column_name: "expiration", filter: true, control: 'number' },
    {
      label: intl.get("Actions").d("Actions"),
      column_name: "actions",
      width: "120px",
      sortable: false,
      element: (row) => (
        <DmsButtonGroup>
          <DmsTableEditButton
            row={row}
            table={table}
            url="/training/"
            title={intl.get("EditTraining").d("Edit Training")}
          />
          <DmsTableDeleteButton
            table={table}
            title={intl.get("DeleteTraining").d("Delete Training")}
            text={intl.get("TrainingPage.DeleteButtonMessage", { name: row.name }).d(`The training {name} will be deleted. Are you sure?`)}
            url="/training/"
            row_pk={row.pk}
          />
        </DmsButtonGroup>
      ),
    },
  ];

  const toolbar = (
    <DmsFlexContainer>
      <DmsFlexContainer.Left>
        <DmsButton variant="primary" icon={<AddIcon />} onClick={handleOpenCreateModal} text={intl.get("CreateTraining").d("Create Training")} />
      </DmsFlexContainer.Left>
    </DmsFlexContainer>
  );

  return (
    <>
      <DmsTable header={header} managed={true} needs_authentication={true} ref={table} url={'/training/table'} toolbar={toolbar} />

      <DmsModal isVisible={isCreateModalOpen} onClose={handleCloseCreateModal}>
        <DmsModal.Header title={intl.get("CreateTraining").d("Create Training")} />
        <DmsModal.Body>
            <Box sx={{mt: 2}}>
                <DmsTextField
                    label={intl.get("Name").d("Name")}
                    value={newTrainingName}
                    onChange={(e) => setNewTrainingName(e.target.value)}
                    fullWidth
                    required
                />
            </Box>
            <Box sx={{mt: 2}}>
                <DmsTextField
                    label={intl.get("Description").d("Description")}
                    value={newTrainingDescription}
                    onChange={(e) => setNewTrainingDescription(e.target.value)}
                    fullWidth
                    multiline
                    rows={4}
                />
            </Box>
            <Box sx={{mt: 2}}>
                <DmsTextField
                    label={intl.get("ValidityMonths").d("Validity (Months)")}
                    value={newTrainingExpiration}
                    onChange={(e) => setNewTrainingExpiration(e.target.value)}
                    fullWidth
                    type="number"
                />
            </Box>
        </DmsModal.Body>
        <DmsModal.Footer>
            <DmsButton variant="secondary" text={intl.get("Cancel").d("Cancel")} onClick={handleCloseCreateModal} />
            <DmsButton variant="primary" onClick={handleCreateSave} text={intl.get("Save").d("Save")} />
        </DmsModal.Footer>
      </DmsModal>
    </>
  );
};
